import { z } from "zod"

export const trimmedString = () => z.string().trim()

export const requiredTrimmedString = (
  requiredMessage: string
) => trimmedString().min(1, requiredMessage)

/**
 * Requires at least 1 non-blank character in the field value, however does not trim whitespace from field value.
 * Useful for password fields where trimming is undesired.
 */
export const requiredNonBlankString = (
  requiredMessage: string
) =>
  z
    .string()
    .min(1, requiredMessage)
    .refine((value) => value.trim().length > 0, {
      message: requiredMessage,
    })

export const emailAddressSchema = (
  requiredMessage: string
) =>
  requiredTrimmedString(requiredMessage).email(
    "Invalid email address"
  )
